import type {InputFieldSize} from '@Components/input-field-v2/input-field.types';
import toNumber from 'lodash/toNumber';

export interface GoogleMapProps {
  apiKey: string;
  onLocationChange?: (place: PlaceDetails | undefined) => void;
  defaultLocation?: PlaceDetails | undefined;
  isViewOnly: boolean; // The map can only be viewed. Not moved, selected etc.
  isAutoCompleteOnly?: boolean; // Only the autocomplete search bar will be available without the map
  selectCurrentLocationAsDefault?: boolean; // The users current location will be selected as the default location.
  mapStyle?: MapStyle;
  shouldSetUserCurrentLocation?: boolean;
  autocompleteInputFieldSize?: InputFieldSize;
}

//America
export const DEFAULT_LATITUDE = 40.7461796;
export const DEFAULT_LONGITUDE = -74.0120506;
export const DEFAULT_LOCATION_ADDRESS = 'Manhattan, NY 10036, United States';

export interface GoogleMapReduxState {
  place?: PlaceDetails;
}

export interface PlaceDetails {
  idAddress?: string; // An existing id in the db
  name?: string;
  address?: string;
  addressDirections?: string;
  longitude: number;
  latitude: number;
  viewport?: google.maps.LatLngBounds;
  placeID?: string; // A Google map ID of a place
  province?: string;
  city?: string;
  country?: string;
  postalCode?: string;
  googleMapUrl?: string;
}

export interface MapStyle {
  isRoundedBorder?: boolean;
  className?: string;
}

export const getLatLngFromPlaceDetails = (placeDetails: PlaceDetails): google.maps.LatLngLiteral => {
  return {
    lat: toNumber(placeDetails.latitude),
    lng: toNumber(placeDetails.longitude),
  };
};

export const USER_LOCATION_TIMEOUT_MS = 150000;
